<!--
  ProfileField: one label/value row with icon tile and right-aligned icon actions (.fld of the acquisition item page).
  Props: icon, label, value (plain text, optional - otherwise default slot), emptyText (shown muted when there is no value
         and no default slot content)
  Slots: default (value), actions (ibtn buttons/links)
-->
<template>
  <div class="fld">
    <span class="fld__icon"><v-icon>{{ icon }}</v-icon></span>
    <div style="min-width: 0">
      <div class="fld__label">{{ label }}</div>
      <slot>
        <div :class="{ 'fld__value--muted': !hasValue }" class="fld__value">{{ hasValue ? value : emptyText }}</div>
      </slot>
    </div>
    <div class="fld__actions">
      <slot name="actions"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    icon: {type: String, required: true},
    label: {type: String, required: true},
    value: {type: [String, Number], default: ''},
    emptyText: {type: String, default: '–'},
  },
  computed: {
    hasValue(): boolean {
      return this.value !== '' && this.value !== null && this.value !== undefined;
    },
  },
});
</script>

<style src="@/components/acquisitionList/ui/itemDetails.css"></style>
